import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { formatINR, useSEO } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function Wishlist() {
  useSEO("Wishlist");
  const { items, remove } = useWishlist();
  const { addItem } = useCart();

  return (
    <div data-testid="wishlist-page" className="pt-32 pb-28">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-4">Saved for later</p>
        <h1 className="font-display text-5xl md:text-7xl tracking-[-0.03em] mb-12">Wishlist</h1>

        {items.length === 0 ? (
          <div className="text-center py-24" data-testid="wishlist-empty">
            <Heart size={40} className="mx-auto mb-6 text-black/20" />
            <p className="text-muted-foreground mb-6">Your wishlist is empty.</p>
            <Link to="/collections" className="inline-block bg-black text-white rounded-full px-8 py-3.5 uppercase text-xs tracking-[0.2em]">Explore collections</Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {items.map((w) => (
              <div key={w.slug} className="group" data-testid={`wishlist-item-${w.slug}`}>
                <Link to={`/product/${w.slug}`} className="block aspect-[4/5] rounded-3xl overflow-hidden bg-[#F5F5F5] zoom-frame">
                  <img src={`${w.image}?w=600&q=80`} alt={w.name} className="w-full h-full object-cover" />
                </Link>
                <div className="mt-3">
                  <div className="flex items-baseline justify-between">
                    <p className="font-display text-lg">{w.name}</p>
                    <span className="text-sm">{formatINR(w.price)}</span>
                  </div>
                  <p className="text-xs text-muted-foreground uppercase tracking-[0.12em]">{w.tagline}</p>
                  <div className="flex gap-2 mt-3">
                    <button onClick={() => { addItem(w, 1); }} data-testid={`wishlist-add-${w.slug}`}
                      className="flex-1 bg-black text-white rounded-full py-2.5 text-[10px] uppercase tracking-[0.15em] inline-flex items-center justify-center gap-1.5">
                      <ShoppingBag size={12} /> Add
                    </button>
                    <button onClick={() => { remove(w.slug); toast.success("Removed"); }} data-testid={`wishlist-remove-${w.slug}`}
                      className="px-4 border border-black/15 rounded-full text-[10px] uppercase tracking-[0.15em]">Remove</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
